import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Tags, Ticket, CreditCard, BarChart3, Users, Settings, LogOut, Menu, User } from 'lucide-react';
const navItems = [{
  path: '/admin',
  label: 'ড্যাশবোর্ড',
  icon: LayoutDashboard,
  end: true
}, {
  path: '/admin/prices',
  label: 'টিকিট মূল্য',
  icon: Tags
}, {
  path: '/admin/sales',
  label: 'টিকিট বিক্রয়',
  icon: Ticket
}, {
  path: '/admin/transactions',
  label: 'পেমেন্ট লেনদেন',
  icon: CreditCard
}, {
  path: '/admin/reports',
  label: 'রিপোর্ট',
  icon: BarChart3
}, {
  path: '/admin/users',
  label: 'ব্যবহারকারী',
  icon: Users
}, {
  path: '/admin/settings',
  label: 'সেটিংস',
  icon: Settings
}];
export function AdminLayout() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="admin-theme flex h-screen bg-slate-50 font-bangla" data-id="element-52">
      {/* Sidebar Overlay */}
      {sidebarOpen && <div className="fixed inset-0 bg-black/50 z-20 lg:hidden" onClick={() => setSidebarOpen(false)} data-id="element-53" />}

      {/* Sidebar */}
      <aside className={`
        fixed lg:static inset-y-0 left-0 z-30 w-64 bg-white border-r border-slate-200 transform transition-transform duration-200 ease-in-out flex flex-col
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `} data-id="element-54">
        <div className="p-5 border-b border-slate-100 bg-gradient-to-br from-[#006A4E] to-[#00875F] text-white" data-id="element-55">
          <div className="flex items-center gap-3" data-id="element-56">
            <img src="https://cdn.magicpatterns.com/uploads/dU3qapA9H2XyT3LbpNWDjq/Government_Seal_of_Bangladesh.svg_1.png" alt="Gov Seal" className="w-10 h-10 object-contain bg-white rounded-full p-0.5" data-id="element-57" />
            <div className="leading-tight" data-id="element-58">
              <h2 className="font-bold text-white text-sm" data-id="element-59">চিম্বুক পাহাড়</h2>
              <p className="text-[11px] text-emerald-100" data-id="element-60">
                জেলা প্রশাসন, বান্দরবন
              </p>
            </div>
          </div>
        </div>

        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1" data-id="element-61">
          {navItems.map(item => <NavLink key={item.path} to={item.path} end={item.end} onClick={() => setSidebarOpen(false)} className={({
          isActive
        }) => `
                flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors
                ${isActive ? 'bg-brand-coral/10 text-brand-coral' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}
              `} data-id="element-62">
              <item.icon className="w-5 h-5" data-id="element-63" />
              {item.label}
            </NavLink>)}
        </nav>

        <div className="p-4 border-t border-slate-100" data-id="element-64">
          <button onClick={() => navigate('/admin/login')} className="flex items-center gap-3 px-3 py-2.5 w-full rounded-xl text-sm font-medium text-slate-600 hover:bg-slate-50 hover:text-destructive transition-colors" data-id="element-65">
            <LogOut className="w-5 h-5" data-id="element-66" />
            লগআউট
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden" data-id="element-67">
        {/* Header */}
        <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 lg:px-8 z-10" data-id="element-68">
          <button onClick={() => setSidebarOpen(true)} className="lg:hidden p-2 -ml-2 text-slate-600 hover:bg-slate-100 rounded-lg" data-id="element-69">
            <Menu className="w-6 h-6" data-id="element-70" />
          </button>

          <div className="hidden lg:flex items-center gap-2 text-sm text-slate-500" data-id="element-71">
            <span data-id="element-72">জেলা প্রশাসন, বান্দরবন পার্বত্য জেলা</span>
          </div>

          <div className="flex items-center gap-4 ml-auto" data-id="element-73">
            <div className="text-right hidden sm:block" data-id="element-74">
              <p className="text-sm font-bold text-slate-900" data-id="element-75">
                Md. Rahim Uddin
              </p>
              <p className="text-xs text-slate-500" data-id="element-76">Super Admin</p>
            </div>
            <div className="w-10 h-10 bg-slate-100 rounded-full flex items-center justify-center border border-slate-200" data-id="element-77">
              <User className="w-5 h-5 text-slate-500" data-id="element-78" />
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto p-4 lg:p-8" data-id="element-79">
          <Outlet data-id="element-80" />
        </main>
      </div>
    </div>;
}